// import React, { useState } from "react";
// import { Localized } from "@fluent/react";
declare var React: any

export function FavoriteButton(props) {
    let Localized = window["FluentReact"].Localized;

    // let [date] = useState(() => new Date());
    return <>

        <button type="button" className="favorite-book-select-button">

            <span className="glyphicon glyphicon-star-empty"></span>
            <span>&nbsp;</span>{ /* XXX: use CSS padding instead */ }

            <Localized id={props.buttonTextId}>
                <span>{
                    // props.buttonText
                    "Select favorite editions"
                }</span>
            </Localized>

        </button>

    </>;
}

/*
devDependencies:
    "@types/react": "^17.0.3",
    "@types/react-dom": "^17.0.3",
*/
